const SECRET = process.env.STORAGE_KEY

async function getKey() {
  const encoder = new TextEncoder();

  const keyMaterial = await crypto.subtle.digest(
    "SHA-256",
    encoder.encode(SECRET)
  );

  return crypto.subtle.importKey(
    "raw",
    keyMaterial,
    { name: "AES-GCM" },
    false,
    ["encrypt", "decrypt"]
  );
}

export async function encrypt(data) {
  const key = await getKey();
  const iv = crypto.getRandomValues(new Uint8Array(12));

  const encoded = new TextEncoder().encode(
    JSON.stringify(data)
  );

  const encrypted = await crypto.subtle.encrypt(
    {
      name: "AES-GCM",
      iv,
    },
    key,
    encoded
  );

  const result = {
    iv: Array.from(iv),
    data: Array.from(new Uint8Array(encrypted)),
  };

  return btoa(JSON.stringify(result));
}

export async function decrypt(text) {
  if (!text) return null;

  try {
    const key = await getKey();

    const parsed = JSON.parse(atob(text));

    const decrypted = await crypto.subtle.decrypt(
      {
        name: "AES-GCM",
        iv: new Uint8Array(parsed.iv),
      },
      key,
      new Uint8Array(parsed.data)
    );

    return JSON.parse(
      new TextDecoder().decode(decrypted)
    );
  } catch (error) {
    console.error("Storage decrypt failed:", error);
    return null;
  }
}